<template>
  <div
    class="backdrop"
    :class="{'younesis': isYounesisProject, 'bodybase': isBodybaseProject, 'fit': fit}"
  >
    <div
      class="logo"
      :style="{ backgroundImage: store.state.app?.appIcons?.logoBgUrl128x58 }"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { urlToCssURL } from '@/utils/urlToCssURL.js';
import store from "@/store/store.js";

export default {
  name: 'Logo',
  props: {
    fit: Boolean,
  },
  computed: {
    store() {
      return store
    },
    ...mapGetters('app', ['isYounesisProject', 'isBodybaseProject']),
  },
  methods: { urlToCssURL }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/variables';

  .backdrop {
    display: inline-flex;
    width: 100%;
    height: 120px;
    align-items: center;
    justify-content: center;
    position: relative;

    &.fit {
      width: fit-content;
      height: fit-content;
    }
    &.younesis:after,
    &.bodybase:after {
      content: '';
      width: 100%;
      height: 239px;
      filter: blur(100px);
      transform: translate3d(0, 0, 0);
      background: rgb(207, 46, 46);
      opacity: 0.08;
      position: absolute;
      top: -119px;
      left: 0;
    }
    .logo {
      display: block;
      //height: var(--logo-home-height, 58px);
      width: 128px;
      height: 58px;
      //background-image: var(--logo-home-src);

      position: relative;
      background-repeat: no-repeat;
      //background: url("@/assets/images/logo/white_logo_leadpay_128_58.svg") no-repeat;
      background-size: contain;
      background-position: center center;
    }
  }

  img {
    user-select: none;
  }
</style>
